export default {
  photo: "Item Image",
  barcode: "Barcode",
  qr_code_image: "QR Code Image",
  id: "ID",
  item_id: "Item ID",
  asset_id: "Asset ID",
  barcode_number: "Barcode Number",
  sku_number: "SKU Number",
  batch_number: "Batch/Lot Number",
  billing_type: "Billing Type",
  manufacture_part_number: "Manufacture Part Number",
  expiration_date: "Expiration Date (MM/YYYY)",
  expiration_month_day_year: "Expiration Date (MM/DD/YYYY)",
  expiration_month: "Expiration Month (MM)",
  expiration_year: "Expiration Year (YYYY)",
  manufacture_date: "Manufacture Date (MM/DD/YYYY)",
  carrier_name: "Carrier Name",
  order_number: "Order Number",
  bol_number: "BOL Number",
  tracking_number: "Tracking Number",
  truck_number: "Truck Number",
  days_left_to_expire: "Days Until Expiration",
  unit_of_measure: "Unit of Measure",
  // imported_custom_attributes: "Imported Custom Attributes",
  square_footage: "Square Footage",
  cubic_footage: "Cubic Footage",
  predefined_cubic_feet: "Predefined Cubic Footage",
  disposition: "Disposition",
  description: "Description",
  description_comments: "Description Comments",
  manufacturer: "Manufacturer",
  color: "Color",
  finishes: "Finish",
  condition: "Condition",
  dimensions: 'Dimensions (W" x D" x H")',
  existing_building: "Origin Building",
  existing_floor: "Origin Floor",
  existing_room: "Origin Room Name",
  origin_room_number: "Origin Room Number",
  origin_cubby_number: "Origin Cubby Number",
  origin_employee_name: "Origin Employee Name",
  quantity: "Origin Quantity",
  origin_comments: "Origin Comments",
  new_building: "Destination Building",
  new_floor: "Destination Floor",
  new_room: "Destination Room Name",
  destination_employee_name: "Destination Employee Name",
  destination_room_number: "Destination Room Number",
  destination_quantity: "Destination Quantity",
  destination_comments: "Destination Comments",
  status: "Status",
  checkin: "Checkin",
  checkout: "Checkout",
  checkout_date: "Checkout Date",
  transferred_by: "Transferred By",
  comments: "Comments",
  signature: "Signature",
  received_by_email: "Received by email",
  received_by_date: "Received by date",
  checkin_agent: "Checkin Agent",
  checkin_status: "Checkin Status",
  checkin_date: "Checkin Date",
  checkout_agent: "Checkout Agent",
  checkout_status: "Checkout Status",
  requested_on: "Requested On",
  started_on: "Started On",
  completed_on: "Completed On",
  destination_room_numbers: "Destination Room Numbers",
  inventory_items_disposition: "Inventory Item Disposition",

  // Administrative custom fields

  // Medical fields
  department_name: "Department Name",
  serial_number: "Serial Number",
  destination_number: "Destination No",
  install_responsibility: "Install Responsibility",
  rack_locations: "Storage Location(s)",
  available_quantity: "Available Quantity",
  quantity_received: "Quantity Received",
  reserved_quantity: "Reserved Quantity",
  minimum_quantity: "Minimum Quantity",
  quantity_ordered: "Quantity Ordered",
  expected_quantity: "Expected Quantity",
  model: "Model",
  attachments: "Attachments",
  ii_image: "Asset Image",
  ii_barcode: "Barcode",
  ii_description: "Description",
  ii_qtyRequested: "Quantity Requested",
  ii_po_number: "PO Number",
  ii_idsr_number: "IDSR #/Project Name",
  ii_eoc_number: "EOC",
  ii_location: "Delivery Location",
  ii_location_address: "Location Address",
  ii_building: "Building",
  ii_floor: "Floor",
  ii_room: "Room",
  ii_deliveryDate: "Delivery Date",
  ii_deliveryTime: "Delivery Time",
  ii_notes: "Outbound Item Notes",
  ii_dimensions: "Dimensions",
  ir_email: "Created By",
  ir_cc_emails: "Recipient Emails",
  ir_work_order_number: "Order Number",
  ir_location: "Delivery Location",
  ir_location_address: "Location Address",
  ir_po_number: "PO Number",
  ir_resources: "Resources",
  ir_comment: "Comment",
  ir_configurable_field_1: "Configurable Field 1",
  ir_configurable_field_2: "Configurable Field 2",
  ir_configurable_field_3: "Configurable Field 3",
  ir_configurable_field_4: "Configurable Field 4",
  ir_configurable_field_5: "Configurable Field 5",
  ir_designer: "Requestor",
  ir_start_date: "Start Date",
  ir_start_time: "Start Time",
  ir_end_date: "End Date",
  ir_end_time: "End Time",
  ir_delivery_date: "Delivery Date",
  ir_attachments: "Attachments",
  ir_contact_name: "Contact Name",
  ir_contact_phone_number: "Contact Phone Number",
  ir_picking_notes: "Optional Picking Notes",
  sc_description: "Description",
  sc_model: "Model",
  sc_storage_location: "Storage Location",
  sc_item_id_overlay: "Item ID Overlay",
  sc_dimensions: "Dimensions",
  sc_available_qty: "Available Quantity",
  sc_price: "Price",
  // sc_asset_id_overlay: "Asset id overlay",
  sc_manufacture: "Manufacturer",
  sc_color: "Color",
  sc_condition: "Condition",
  sc_item_code: "Item Code",
  sc_expiration: "Expiration",
  item_code: "Item Code",
  unit_cost: "Unit Cost",
  category: "Category",
  subcategory: "Subcategory",
  order_work_order_number: "Order #",
  order_requested_at: "Requested At",
  order_requested_by: "Requested By",
  order_start_date: "Start Date",
  order_project_name: "Project Name",
  order_delivery_date: "Delivery Date",
  order_destination: "Destination",
  order_pdf_report: "PDF Report",
  order_va_status: "Order Status",
  order_actions: "Actions",
  order_comments: "Order Comments",
  order_release_notes: "Release Notes",
  order_configurable_field_3: "Configurable Field 3",
  reservation_order_number: "Reservation #",
  reservation_create_on: "Created On",
  reservation_age: "Reservation Age",
  reservation_for: "Reserved For",
  reservation_po_number: "PO#",
  reservation_notes: "Notes",
  reservation_requested_by: "Submitted By",
  reservation_customer_name: "Customer Name",
  reservation_actions: "Actions",
  power: "Power",
  weight: "Unit Weight (lbs)",
  asset_total_weight: "Asset Total Weight",
  po_number: "PO Number",
  warehouse_quantity: "Quantity in Warehouse",
  allocated_quantity: "Quantity to Be Picked",
  last_in: "Last In",
  last_out: "Last Out",
  in_cart_quantity: "Quantity in Cart",
  shipment_id: "Shipment ID",
  vendor_name: "Vendor Name",
  carrier_name: "Carrier Name",
  order_number: "Order Number",
  bol: "BOL",
  total_weight: "Total Weight",
  shipment_notes: "Notes",
  tracking_number: "Tracking Number",
  customer_po_number: "Shipment PO Number",
  total_receiving_units: "Total Receiving Units",
  receiving_report_number: "Inbound Summary",
  outbound_summary: "Outbound Summary",
  pallet_type: "Pallet Type",
  unit_type: "Unit Type",
  square_footage_type: "Square Footage Type",
  created_at: "Created On",
  updated_at: "Updated On",
  // billing_category: "Billing Category",
  osd_notes: "OS&D Notes",
  general_notes: "General Notes",
  packing: "Packing",
  shipment_item_quantity: "Shipment Item Quantity",
  truck_number: "Truck Number",
  billing_type: "Billing Type",
  cost_center: "Cost Center",
  warehouse_name: "Warehouse Name",
  asset_label_pdf: "Item Label PDF",
};
